<div class="search">
  <!-- CLEAR SEARCH -->
  <ion-button
    *ngIf="inputValue?.length > 0 && !xhrInProgress"
    color="secondary"
    fill="clear"
    class="search-action"
    (click)="clearSearch()"
  >
    <ion-icon name="close-circle-outline"></ion-icon>
  </ion-button>

  <!-- PROGRESS INDICATOR -->
  <ion-button
    *ngIf="xhrInProgress"
    color="secondary"
    fill="clear"
    class="search-action"
  >
    <ion-spinner slot="icon-only" name="crescent"></ion-spinner>
  </ion-button>

  <!-- SEARCH INPUT -->
  <ion-input
    type="text"
    [maxlength]="maximumCharacters"
    [debounce]="debounceTime"
    (ionChange)="searchQueryOnDataSource($event)"
    (ionFocus)="focusInput()"
    (ionBlur)="blurInput()"
    (keyup.enter)="enterInput()"
    [(ngModel)]="inputValue"
  ></ion-input>

  <!-- AUTOCOMPLETE LIST -->
  <div class="autocomplete" #filterList>
    <ul class="sub-list" *ngIf="resultDataList && resultDataList.length > 0">
      <li
        *ngFor="let result of resultDataList | slice: 0:6; trackBy: trackBySlug"
        (click)="selectedResult(result)"
      >
        <div
          *ngIf="resultDataList.length > 1"
          [innerHTML]="result?.match"
        ></div>
        <span
          *ngIf="resultDataList.length === 1"
          [innerHTML]="result?.match ? result?.match : result?.title"
        ></span>
      </li>
      <li *ngIf="resultDataList.length > 6" class="static-msg">
        <div>+{{ resultDataList.length - 6 }} More</div>
      </li>
    </ul>
  </div>
</div>
